export default {
    getTypeSubscriptions: { method: 'get', url: 'signatures/type-subscriptions' },
    getTypeInstitutionSubscriptions: { method: 'get', url: 'signatures/type-institution-subscriptions' },
    postTypeInstitutionSubscriptions: { method: 'post', url: 'signatures/type-institution-subscriptions' },
    putTypeInstitutionSubscriptions: { method: 'put', url: 'signatures/type-institution-subscriptions/{id}' },
    deleteTypeInstitutionSubscriptions: { method: 'delete', url: 'signatures/type-institution-subscriptions/{id}' },
}